<template>
  <div 
    :id="appid" 
    class="vue-form vf-form">
    <div 
      v-if="status.error" 
      class="callout alert">
      {{ status.error }}
    </div>
    <div 
      v-else-if="status.ready" 
      class="form">
      <form-component
        v-if="!status.complete" 
        :options="options">
      </form-component>
      <confirmation 
        v-else 
        :message="status.message">
      </confirmation>
    </div>
  </div>
</template>

<script>
import Confirmation from '@/Confirmation.vue'
import Form from '@/Form.vue'

export default {
  name: 'App',
  components: {
    Confirmation,
    'form-component': Form
  },
  computed: {
    appid () {
      return this.$options.appid
    },
    options () {
      return this.$store.config
    },
    status () {
      return this.$store.status
    }
  }
}
</script>
